// extracted by mini-css-extract-plugin
export default {"overlay":"CarrotRainEasterEgg_overlay__c2XBO","carrot":"CarrotRainEasterEgg_carrot__o3eTe","carrot-fall":"CarrotRainEasterEgg_carrot-fall__ZawRJ"};